import { DataSourceRegistryPath } from "@/features/data-source/data-source-registry";
import { UseDataSourceResult } from "@/features/data-source/data-source.types";
import { getDataSourceQueryArgs } from "@/features/data-source/data-source.utils";
import { useGetDataSourceQuery } from "@/store/services/data-source.service";

/**
 * Fetch data from a data source based on the provided arguments.
 *
 * @param dataSourcePath The registry path of the data source to query.
 * @param parameters Optional parameters for the data source.
 * @param options Optional settings, e.g., skip.
 * @returns The result of the data source query.
 */
export const useDataSource = <T = unknown>(
    dataSourcePath: DataSourceRegistryPath,
    parameters?: Record<string, string | number | boolean>,
    options?: { skip?: boolean },
): UseDataSourceResult<T> => {
    const args = getDataSourceQueryArgs(dataSourcePath, parameters);
    const result = useGetDataSourceQuery(args, { skip: options?.skip });

    return result;
};
